// extracted by mini-css-extract-plugin
export default {"container":"tO-z","modal":"uO-z","dimensions":"vO-z","brandName":"wO-z","productName":"xO-z","labelValue":"yO-z","recipientEmail":"zO-z","recommendedFit":"AO-z","hiddenField":"BO-z"};